import Controller from './controller'

export default class extends Controller {
  initialize() {}

  toggle() {
    this.element.classList.toggle('is-open')
  }
}
